var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.88 15.353l5.3 5.22a.89.89 0 010 1.277.928.928 0 01-1.3 0l-5.301-5.216a9.33 9.33 0 01-5.886 2.07C4.558 18.703.4 14.603.4 9.551.4 4.499 4.558.4 9.693.4c5.13 0 9.292 4.1 9.292 9.152a9.035 9.035 0 01-2.106 5.8zM2.243 9.552c0 4.042 3.34 7.33 7.448 7.33 4.104 0 7.447-3.288 7.447-7.33s-3.343-7.335-7.447-7.335c-4.109 0-7.448 3.293-7.448 7.335z",
    fill: "#fff"
  })));
}
export default SvgSearchIcon;